// extracted by mini-css-extract-plugin
module.exports = {"ST_moreInfoContainer":"PageDesc-module__ST_moreInfoContainer"};